import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CourseTypeToggle',
  props: {
    activeCourseType: {
      type: String as () => 'written' | 'oral',
      required: true,
    },
  },
  emits: ['toggle'],
  setup(__props, { emit }) {

  

  

  const handleToggle = (type: 'written' | 'oral') => {
    emit('toggle', type)
  }

return { __sfc: true,emit, handleToggle }
}

})